import React, { useState } from "react";
import { Scoodle2FADefaultPage } from "../../../04templates/scoodle/2FADefaultPage/Scoodle2FADefaultPage";
import {
	Body3,
	H1,
} from "pu-crossproduct-components/build/components/Atoms/Type";
import {
	GridContainer,
	GridItem,
	GridRow,
} from "pu-crossproduct-components/build/components/Atoms/Grid";
import { Trans, useTranslation } from "react-i18next";
import {
	Button,
	ButtonColors,
	Size,
} from "pu-crossproduct-components/build/components/Molecules/Navigation/Button";
import {
	Link,
	LinkColors,
} from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import styled from "styled-components";
import { Scoodle2FAExplanation } from "../Scoodle2FAExplanation/Scoodle2FAExplanation";
import { Checkbox } from "pu-crossproduct-components/build/components/Molecules/Inputs/Selection";

const ButtonContainer = styled.div`
    button {
        width: 383px;
    }
`;

const CheckboxHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 10px;
  line-height: 40px;
`;

interface IScoodle2FA {
	onRememberChanged: (value: boolean) => void;
	onConfirm: () => void;
}

export const Scoodle2FA: React.FC<IScoodle2FA> = (props) => {
	const { t } = useTranslation();
	const [explanationOpen, setExplanationOpen] = useState<boolean>(false);
	const rememberDays = 14;

	return (
		<Scoodle2FADefaultPage>
			<GridContainer>
				<GridRow>
					<GridItem col={0} laptop={2} />
					<GridItem col={12} laptop={8}>
						<div style={{ textAlign: "center" }}>
							<H1>{t("twoFactorScoodleTitle")}</H1>
							<br />
							<Body3>{t("twoFactorScoodleBody")}</Body3>
						</div>
					</GridItem>
				</GridRow>
			</GridContainer>

			<br />
			<br />
			<br />

			<ButtonContainer>
				<Button size={Size.large} onClick={props.onConfirm}>
					{t("twoFactorScoodleConfirmButton")}
				</Button>
			</ButtonContainer>
			<CheckboxHolder>
				<Checkbox
					name="rememberMe"
					value="true"
					onChange={(e) => props.onRememberChanged(e)}
				>
					<Trans t={t} values={{ rememberDays: rememberDays }}>
						twoFactorScoodleRemember
					</Trans>
				</Checkbox>
			</CheckboxHolder>

			<br />

			<Link color={LinkColors.primary} onClick={() => setExplanationOpen(true)}>
				{t("twoFactorScoodleExplanationLink")}
			</Link>

			<Scoodle2FAExplanation
				open={explanationOpen}
				onClose={() => setExplanationOpen(false)}
			/>
		</Scoodle2FADefaultPage>
	);
};
